import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

class Tabs {

	constructor() {
		this.els = document.getElementsByClassName('tab');
		this.tabs = this.initTabs();

		// Classes to toggle between for tabs and accordions
		this.classes = {
			el: {
				tab: "tab",
				accordion: "accordion"
			},
			trigger: {
				tab: "tab-trigger",
				accordion: "accordion-trigger"
			},
			label: {
				tab: "tab-label",
				accordion: "accordion-label"
			},
			content: {
				tab: "tab-content",
				accordion: "accordion-content"
			},
			contentInner: {
				tab: "tab-content-inner",
				accordion: "accordion-content-inner"
			}
		};

		if(document.documentElement.clientWidth < breakpoints.sm) {
			this.tabsToAccordions();
		}

		const outerscope = this;

		window.addEventListener("resize", function() {
			if(document.documentElement.clientWidth < breakpoints.sm) {
				outerscope.tabsToAccordions();
			} else {
				outerscope.accordionsToTabs();
			}
		});
	}

	initTabs() {
		const tabs = [];
		helpers.forEach(this.els, (i, el) => {
			tabs.push(new Tab(el));
		});
		return tabs;
	}

	tabsToAccordions() {
		helpers.forEach(this.tabs, (i, tab) => {
			tab.el.className = this.classes.el.accordion;
			tab.trigger.className = this.classes.trigger.accordion;
			tab.trigger.type = "checkbox";
			tab.trigger.checked = false;
			tab.label.className = this.classes.label.accordion;
			tab.content.className = this.classes.content.accordion;
			tab.contentInner.className = this.classes.contentInner.accordion;
		});
	}

	accordionsToTabs() {
		helpers.forEach(this.tabs, (i, tab) => {
			tab.el.className = this.classes.el.tab;
			tab.trigger.className = this.classes.trigger.tab;
			tab.trigger.type = "radio";
			tab.trigger.checked = i === 0 ? true : false;
			tab.label.className = this.classes.label.tab;
			tab.content.className = this.classes.content.tab;
			tab.contentInner.className = this.classes.contentInner.tab;
		});
	}
}

class Tab {

	constructor(el) {
		this.el = el;
		this.trigger = el.querySelector("tab-trigger");
		this.label = el.querySelector("tab-label");
		this.content = el.querySelector("tab-content");
		this.contentInner = el.querySelector("tab-content-inner");
	}
}

function initTabsAccordions() {
	const accordionLabels = document.querySelectorAll(".accordion-label");
	helpers.forEach(accordionLabels, (i, label) => {
		label.addEventListener('click', function() {
			this.parentElement.classList.toggle('open');
		});
	});

	const tabs = new Tabs();
};

document.addEventListener('DOMContentLoaded', initTabsAccordions);
